import React from 'react'

function PrintPurchaseInvoice(props) {
  return (
   
<div id="thermalpospurcahsecosmetics">
    

<div style={{textAlign:'center',marginTop:'-5px'}}>
  <h2 style={{marginBottom:'-15px'}}>Purchase Invoice</h2>
  <h4 >{props.data.customer.name}</h4>
</div>


<div style={{display:'flex',justifyContent:'space-between',paddingLeft:'20px',paddingRight:'20px'}}>
  <div style={{padding:'10px'}}>
    <div style={{marginBottom:'10px'}}>
     <b>Name</b>:<span id="customername">{props.data.customer.name}</span> 
    </div>
  <div style={{marginBottom:'8px'}}>
   <b>Address</b>:<span id="customerlocation">{props.data.customer.city}</span>
    </div>
     <div style={{marginBottom:'8px'}}>
    <b>Contact</b>:<span id="customerphone">{props.data.customer.phone}</span>
    </div>

   
  </div>
  <div style={{padding:'10px'}}>
    
     <div style={{marginBottom:'8px'}}>
     <b>Invoice</b>:<span id="rinvoiceno">{props.data.invoiceno}</span> 
    </div>

     

     <div style={{marginBottom:'8px'}}>
     <b>Type</b>:<span id="paytype">Credit/Cash</span> 
    </div>
  </div>
</div>



<div>

  <div style={{paddingRight:'10px',paddingLeft:'10px',marginTop:'1px',marginLeft:'10px',marginRight:'10px'}}>
    
    
  
     <table style={{width:'100%',fontSize:'12px'}}>
        <thead >
              <tr>
 <th  style={{textAlign:'left',border:'1px solid #dddddd'}}>Sr#</th>

                        <th style={{textAlign:'left',border:'1px solid #dddddd'}}>Item Name</th>
                        <th  style={{textAlign:'left',border:'1px solid #dddddd'}}>Cotton</th>
                        <th style={{textAlign:'left',border:'1px solid #dddddd',display:'none'}}>Case</th>
                        <th style={{textAlign:'left',border:'1px solid #dddddd'}}>Qty</th>

                        <th  style={{textAlign:'left',border:'1px solid #dddddd'}}>Unit</th>
                         <th  style={{textAlign:'left',border:'1px solid #dddddd'}}>Weight</th>
                          
                        <th  style={{textAlign:'left',border:'1px solid #dddddd'}}>Rate</th>
                        <th   style={{textAlign:'left',border:'1px solid #dddddd'}}>Gst</th>
                         <th  style={{textAlign:'left',border:'1px solid #dddddd'}}>Dis</th>
                         <th   style={{textAlign:'left',border:'1px solid #dddddd'}}>ws. Margin</th>
                         <th   style={{textAlign:'left',border:'1px solid #dddddd'}}>Ret.Margin</th>
                        <th   style={{textAlign:'left',border:'1px solid #dddddd'}}>Amount</th>
                       
                    </tr>

        </thead>

        <tbody id="printcartreciept">
          {props.data.cart && props.data.cart.map((item,index)=>(


          
        <tr key={item.id}>
 <td style={{textAlign:'left',border:'1px solid #dddddd'}}>{index+1}</td>

                        <td  style={{textAlign:'left',border:'1px solid #dddddd'}}>{item.name}</td>
                        <td style={{textAlign:'left',border:'1px solid #dddddd'}}>{parseFloat(item.qty/item.pack_size)}</td>
                        <td style={{textAlign:'left',border:'1px solid #dddddd',display:'none'}}>{item.pack_size}</td>
                        <td  style={{textAlign:'left',border:'1px solid #dddddd'}}>{item.qty}</td>

                        <td  style={{textAlign:'left',border:'1px solid #dddddd'}}>{item.unit}</td>
                         <td  style={{textAlign:'left',border:'1px solid #dddddd'}}>{item.weight}</td>
                          
                        <td  style={{textAlign:'left',border:'1px solid #dddddd'}}>{item.unitcostprice}</td>
                        <td   style={{textAlign:'left',border:'1px solid #dddddd'}}>{item.gst}</td>
                         <td  style={{textAlign:'left',border:'1px solid #dddddd'}}>{item.discount}%({item.totaldiscount})</td>
                         <td   style={{textAlign:'left',border:'1px solid #dddddd'}}>{item.totalwholesalemargin}</td>
                         <td   style={{textAlign:'left',border:'1px solid #dddddd'}}>{item.retailmargin}</td>
                        <td   style={{textAlign:'left',border:'1px solid #dddddd'}}>{(item.unitcostprice*item.qty).toFixed(2)}</td>
                       
                    </tr>
))}

        </tbody>
      
    </table>

  </div>
  
     <div style={{marginLeft:'20px',marginRight:'20px',padding:'15px',display:'flex',justifyContent:'space-between',marginTop:'20px',fontSize:'15px'}}>
      
          
        

          <div>
               
    <div style={{textAlign:'left'}}>
 Amount Exc.Tax=<span id="rsupergrandtotal">{parseFloat(props.data.totalwithgst).toFixed(2)}</span>Rs
    </div>
    <div style={{textAlign:'left'}}>
   Invoiced Sales Tax= <span id="rsale_tax">{props.data.totalgst}</span>Rs
    </div>

    <div style={{textAlign:'left'}}>
   Amount incl. Tax= <span id="rsupergrandtotalwithsalestax">{parseFloat(parseFloat(props.data.totalwithgst)+parseFloat(props.data.totalgst)).toFixed(2)}</span>Rs
    </div>
   
    <div style={{textAlign:'left'}}>
       W/S Margin= <span id="wsmargin">{parseFloat(props.data.totalwholesalemargin)}</span>Rs
    </div>
    <div style={{textAlign:'left'}}>
       Retail Margin= <span id="retailmargin">{parseFloat(props.data.totalretailmargin)}</span>Rs
    </div>
      <div style={{textAlign:'left'}}>
       Discount= <span id="rtotaldiscount">{props.data.totaldiscount}</span>Rs
    </div>
     <div style={{textAlign:'left'}}>
      Payment= <span id="rpayment">{props.data.totalpaid}</span>Rs
    </div>
    
     <div style={{textAlign:'left'}}>
        Invoiced Payable=<span id="rbalance">{parseFloat((parseFloat(props.data.totalwithgst)-parseFloat(props.data.totaldiscount)-parseFloat(props.data.totalretailmargin)-parseFloat(props.data.totalwholesalemargin)-parseFloat(props.data.totalpaid)+parseFloat(props.data.totalgst))).toFixed(2)}</span>Rs
    </div>

{(props.data.mesg==='PURCHASE INVOICE')?
     <div style={{textAlign:'left'}}>
        Pre Balance=<span id="pbalance">{(props.data.pbalance).toFixed(2)}</span>Rs
    </div> 
:
<div>

  
</div>

}

     <div style={{textAlign:'left'}}>
        Total Payable=<span id="totaldue">{parseFloat((parseFloat(props.data.totalwithgst)-parseFloat(props.data.totaldiscount)-parseFloat(props.data.totalretailmargin)-parseFloat(props.data.totalwholesalemargin)-parseFloat(props.data.totalpaid)+parseFloat(props.data.pbalance)+parseFloat(props.data.totalgst))).toFixed(2)}</span>Rs
    </div>
          </div>
       </div>


    
</div>


</div>
  )
}

export default PrintPurchaseInvoice
